const ICON_CHEVRON_DOWN =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14 8-4 4-4-4"/></svg>'

function SortAccordion (sortOptions = []) {
  if (!sortOptions || sortOptions.length === 0) {
    return ''
  }

  const urlParams = new URLSearchParams(window.location.search)
  const isActive = urlParams.has('sort')

  const sortOptionsTemplate = sortOptions
    .map((option) => {
      const id = `results-${option.field}-${option.order}`

      return `
        <li class="clc-ProductGridFacet_Item">
          <label
            class="clc-ProductGridFacet_Label fz-13_100"
            for="${id}"
          >
            <input
              id="${id}"
              class="clc-ProductGridFacet_Checkbox"
              type="radio"
              name="sort_by"
              value="${option.field}~${option.order}"
              ${option.selected ? 'checked' : ''}
            >

            ${option.label}
          </label>
        </li>
      `
    })
    .join('')

  return `
    <div class="drw-ProductGridFacets_Item">
      <button
        type="button"
        class="drw-ProductGridFacets_Trigger fz-14_100"
        aria-controls="sortby-accordion"
        data-accordion-group-el="trigger"
        aria-expanded="${isActive ? 'true' : 'false'}"
        data-results-filters-el="facet"
        data-index="results-sort-trigger"
      >
        ${window.theme.strings.sections.collectionTemplate.sortByLabel}

        <span class="drw-ProductGridFacets_TriggerIcon">
          ${ICON_CHEVRON_DOWN}
        </span>
      </button>

      <div
        id="sortby-accordion"
        class="drw-ProductGridFacets_Accordion"
        aria-hidden="${isActive ? 'false' : 'true'}"
        data-accordion-group-el="content"
        data-results-filters-el="facet"
        data-index="results-sort-content"
      >
        <div class="drw-ProductGridFacets_AccordionContent">
          <ul class="clc-ProductGridFacet_Items">
            ${sortOptionsTemplate}
          </ul>
        </div>
      </div>
    </div>
  `
}

window.templates.SortAccordion = SortAccordion
